import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminAuthorizationGuard } from '@shared/guard/admin-authorization.guard';
import { adminRoutes } from './constants';
import {
  AdminDashboardPageComponent,
  AdminTabsPageComponent,
  ClientsPageComponent,
  EntityTypesPageComponent,
  ExternalUsersPageComponent,
  GeneralRatesRuleEnginePageComponent,
  InternalUsersPageComponent,
  InvestmentJurisdictionsPageComponent,
  ResidencyJurisdictionsPageComponent,
  SecurityTypesPageComponent,
  UsersPageComponent,
} from './pages';
import { RulesManagerPageComponent } from './pages/rules-manager-page/rules-manager-page.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AdminDashboardPageComponent,
    canActivateChild: [adminAuthorizationGuard],
  },
  {
    path: '',
    component: AdminTabsPageComponent,
    children: [
      {
        path: adminRoutes.entityTypes,
        component: EntityTypesPageComponent,
      },
      {
        path: adminRoutes.clients,
        component: ClientsPageComponent,
      },
      {
        path: adminRoutes.securityTypes,
        component: SecurityTypesPageComponent,
      },
      {
        path: adminRoutes.residencyJurisdictions,
        component: ResidencyJurisdictionsPageComponent,
      },
      {
        path: adminRoutes.investmentJurisdictions,
        component: InvestmentJurisdictionsPageComponent,
      },
      {
        path: adminRoutes.generalRatesRuleEngine,
        component: GeneralRatesRuleEnginePageComponent,
      },
      {
        path: adminRoutes.rulesManager,
        component: RulesManagerPageComponent,
      },
      {
        path: adminRoutes.users.root,
        pathMatch: 'full',
        redirectTo: `${adminRoutes.users.root}/${adminRoutes.users.internalUsers}`,
      },
      {
        path: adminRoutes.users.root,
        component: UsersPageComponent,
        children: [
          {
            path: adminRoutes.users.internalUsers,
            component: InternalUsersPageComponent,
          },
          {
            path: adminRoutes.users.externalUsers,
            component: ExternalUsersPageComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
